import { render, staticRenderFns } from "./company-create.vue?vue&type=template&id=4cf34a2e&"
import script from "./company-create.vue?vue&type=script&lang=ts&"
export * from "./company-create.vue?vue&type=script&lang=ts&"
import style0 from "./company-create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports